export default __webpack_public_path__ + "static/media/html.cef80c77.svg";